(function (root) {
  'use strict';

  const namespace = root.Kate3DPreview = root.Kate3DPreview || {};
  if (namespace.HistoryStore) return;

  const EMPTY_HISTORY = () => ({ previewHistory: { wall: [], floor: [] }, previewHistoryId: [] });

  class HistoryStore {
    constructor(storageKey = '3d-preview-history') {
      this.storageKey = storageKey;
      this.state = EMPTY_HISTORY();
    }

    snapshot() {
      return JSON.parse(JSON.stringify(this.state));
    }

    load() {
      try {
        const cachedData = localStorage.getItem(this.storageKey);
        if (!cachedData) return this.snapshot();
        const parsedData = JSON.parse(cachedData);
        if (
          parsedData?.previewHistory &&
          Array.isArray(parsedData.previewHistory.wall) &&
          Array.isArray(parsedData.previewHistory.floor) &&
          Array.isArray(parsedData.previewHistoryId)
        ) {
          this.state = {
            previewHistory: parsedData.previewHistory,
            previewHistoryId: parsedData.previewHistoryId,
          };
        }
      } catch (error) {
        console.error('Unable to load 3D preview history:', error);
      }
      return this.snapshot();
    }

    add(type, product, image) {
      if (!['wall', 'floor'].includes(type) || !product?.id) return this.snapshot();
      if (this.state.previewHistoryId.includes(product.id)) return this.snapshot();

      this.state.previewHistory[type].push({
        id: product.id,
        title: product.title,
        handle: product.handle,
        image,
        timestamp: new Date().toISOString(),
        type,
      });
      this.state.previewHistoryId.push(product.id);
      this.save();
      return this.snapshot();
    }

    save() {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({
          ...this.state,
          timestamp: new Date().toISOString(),
        }));
      } catch (error) {
        console.error('Unable to save 3D preview history:', error);
      }
    }

    clear() {
      try {
        localStorage.removeItem(this.storageKey);
      } catch (error) {
        console.error('Unable to clear 3D preview history:', error);
      }
      this.state = EMPTY_HISTORY();
      return this.snapshot();
    }
  }

  namespace.HistoryStore = HistoryStore;
})(window);
